import { render, staticRenderFns } from "./yearmon.vue?vue&type=template&id=456a96e6&scoped=true"
import script from "./yearmon.vue?vue&type=script&lang=js"
export * from "./yearmon.vue?vue&type=script&lang=js"
import style0 from "./yearmon.vue?vue&type=style&index=0&id=456a96e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456a96e6",
  null
  
)

export default component.exports